import useRuntimeFeatureFlagsStore from '@/features/feature-flags/stores/runtime-feature-flags';

export default function useFeatureFlags() {
  return useRuntimeFeatureFlagsStore((state) => state.featureFlags);
}
